import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Shared headers & auth
import Login from "../pages/Auth/Login/Login";
import Signup from "../pages/Auth/SignUp/Signup.jsx";
import SignupComplete from "../pages/Auth/SignUp/SignupComplete.jsx";
import FindAccount from "../pages/Auth/FindAccount/FindAccount.jsx";
import FindIdResult from "../components/FindIdResult";
import PasswordReset from "../pages/Auth/PasswordReset/PasswordReset";
import EditInfo from "../pages/UserProfile/EditMyInfo/EditInfo.jsx";


//take a look pages
import TakeLookPCFullView from "../pages/TakeALook/FullView/TakeLookPCFullView";
import TakeLookPCSkyHall from "../pages/TakeALook/SkyHall/TakeLookPCSkyHall";
import TakeLookPCSunlightHall from "../pages/TakeALook/SunlightHall/TakeLookPCSunlightHall";
import TakeLookPCSHall from "../pages/TakeALook/SHall/TakeLookPCSHall";
import TakeLookPCAHall from "../pages/TakeALook/AHall/TakeLookPCAHall";
import TakeLookPCSkyHallVIP from "../pages/TakeALook/SkHallVIP/TakeLookPCSkyHallVIP";
import TakeLookPCStarlightHall from "../pages/TakeALook/StarHall/TakeLookPCStarlightHall";
import TakeLookPCFamilyHall from "../pages/TakeALook/FamilyHall/TakeLookPCFamilyHall";
import TakeLookPCOutdoorHall from "../pages/TakeALook/OutdoorHall/TakeLookPCOutdoorHall";

// Desktop pages
import Home from "../pages/Home/Home";
import HomePC from "../pages/Home/HomePC";
import LoginPC from "../pages/Auth/Login/LoginPC";
import SignupPC from "../pages/Auth/SignUp/SignupPC.jsx";
import FindAccountPC from "../pages/Auth/FindAccount/FindAccountPC.jsx";
import FindIdResultPC from "../components/FindIdResultPC";
import PasswordResetPC from "../pages/Auth/PasswordReset/PasswordResetPC";
import EditInfoPC from "../pages/UserProfile/EditMyInfo/EditInfoPC.jsx";

// Memorial pages (new)
import AncestralTabletMobile from "../pages/FamilyPlaza/Ancestral/AncestralTabletMobile";
import AncestralTabletPC from "../pages/FamilyPlaza/Ancestral/AncestralTabletPC";


//introduction-pages
import CEOGreetingPC from "../pages/Introduction/CEOGreetings/CEOGreetingPC";
import IntroductionPC from "../pages/Introduction/IntroductionMemorial/IntroductionPC";
import FacilityGuidePC from "../pages/Introduction/Facilities/FacilityGuidePC";
import MemorialGalleryListPC from "../pages/Introduction/MemorialGallery/MemorialGalleryListPC";
import GalleryDetailsPC from "../pages/Introduction/MemorialGallery/GalleryDetailsPC";
import DirectionsPC from "../pages/Introduction/Direction/DirectionsPC.jsx";


// Sales detail pages (PC/Mobile)
import SkyHallSpecialRoomPC from "../pages/Sales-Information/Sale-Price/SkyHallSpecialRoom/SkyHallSpecialRoomPC";
import SkyHallSpecialRoomMobile from "../pages/Sales-Information/Sale-Price/SkyHallSpecialRoom/SkyHallSpecialRoomMobile";
import SkyHallPhoenixRoomPC from "../pages/Sales-Information/Sale-Price/SkyPhoenixRoom/SkyHallPhoenixRoomPC";
import SkyHallPhoenixRoomMobile from "../pages/Sales-Information/Sale-Price/SkyPhoenixRoom/SkyHallPhoenixRoomMobile";
import SkyHallVIPPC from "../pages/Sales-Information/Sale-Price/SkyHallVIPSale/SkyHallVIPPC";
import SkyHallVIPMobile from "../pages/Sales-Information/Sale-Price/SkyHallVIPSale/SkyHallVIPMobile";
import StarHallPC from "../pages/Sales-Information/Sale-Price/StarHallSale/StarHallPC";
import StarHallMobile from "../pages/Sales-Information/Sale-Price/StarHallSale/StarHallMobile";
import SunlightHallPC from "../pages/Sales-Information/Sale-Price/SunlightHallSale/SunlightHallPC";
import SunlightHallMobile from "../pages/Sales-Information/Sale-Price/SunlightHallSale/SunlightHallMobile";
import SHallPC from "../pages/Sales-Information/Sale-Price/SHallBuilding/SHallPC";
import SHallMobile from "../pages/Sales-Information/Sale-Price/SHallBuilding/SHallMobile";
import OutdoorHallPC from "../pages/Sales-Information/Sale-Price/OutdoorHallSale/OutdoorHallPC";
import OutdoorHallMobile from "../pages/Sales-Information/Sale-Price/OutdoorHallSale/OutdoorHallMobile";
import SaleInfo from "../pages/Sales-Information/Sales-info/SaleInfo";

// Sangjo-page-details
import ProductInfoPC from "../pages/Sangjo-Ujieon/ProductInformation/ProductInfo/ProductInfoPC";
import ProductInfoMobile from "../pages/Sangjo-Ujieon/ProductInformation/ProductInfo/ProductInfoMobile";
import OpeningMovingPC from "../pages/Sangjo-Ujieon/OpeningRelocation/OpeningMovingPC";
import OpeningMovingMobile from "../pages/Sangjo-Ujieon/OpeningRelocation/OpeningMovingMobile";
import GeneralFuneralProceduresPC from "../pages/Sangjo-Ujieon/FuneralInformation/GeneralFuneral/GeneralFuneralProceduresPC";
import GeneralFuneralProceduresMobile from "../pages/Sangjo-Ujieon/FuneralInformation/GeneralFuneral/GeneralFuneralProcedureMobile";
import ServiceAdvantagesPC from "../pages/Sangjo-Ujieon/ProductInformation/ServiceAdvantages/ServiceAdvantagesPC";
import ServiceAdvantagesMobile from "../pages/Sangjo-Ujieon/ProductInformation/ServiceAdvantages/ServiceAdvantagesMobile";
import EventProcedurePC from "../pages/Sangjo-Ujieon/ProductInformation/EventProcedure/EventProcedurePC";
import EventProcedureMobile from "../pages/Sangjo-Ujieon/ProductInformation/EventProcedure/EventProcedureMobile";
import FuneralInfoReligiousMobile from "../pages/Sangjo-Ujieon/FuneralInformation/ReligiousFuneral/FuneralInfoReligiousMobile";
import FuneralInformationReligiousPC from "../pages/Sangjo-Ujieon/FuneralInformation/ReligiousFuneral/FuneralInformationReligiousPC";
import FuneralMethodsMobile from "../pages/Sangjo-Ujieon/FuneralInformation/FuneralMethods/FuneralMethodsMobile";
import FuneralMethodsPC from "../pages/Sangjo-Ujieon/FuneralInformation/FuneralMethods/FuneralMethodsPC";
import FuneralInfoOtherMobile from "../pages/Sangjo-Ujieon/FuneralInformation/FuneralInfoOther/FuneralInfoOtherMobile";
import FuneralInformationOtherPC from "../pages/Sangjo-Ujieon/FuneralInformation/FuneralInfoOther/FuneralInformationOtherPC";

// Announcements & Memorial News
import AnnouncementList from "../pages/customer-service-center/Announcement/AnnouncementList";
import AnnouncementDetails from "../pages/customer-service-center/Announcement/AnnouncementDetails";
import MemorialNewsList from "../pages/customer-service-center/MemorialNews/MemorialNewsList";
import MemorialNewsDetails from "../pages/customer-service-center/MemorialNews/MemorialNewsDetails";
import FAQCustomerCenter from "../pages/customer-service-center/FAQ/FAQ";
import ContactUs from "../pages/customer-service-center/ContactUs/ContactUs";
import InquiryDetails from "../pages/customer-service-center/ContactUs/InquiryDetails";
import ContactUsWriting from "../pages/customer-service-center/ContactUs/ContactUsWriting";
import SecretPost from "../pages/customer-service-center/ContactUs/SecretPost";

// footer-pages
import PrivacyPolicy from "../pages/footer-pages/PrivacyPolicy";
import RefusalOfUnauthorized from "../pages/footer-pages/RefusalOfUnauthorized";
import TermsCondition from "../pages/footer-pages/terms-condition";
import ServiceUseNotice from "../pages/ErrorPgae/ServiceUseNotice";


// Boards
import MemorialPostBoardListPC from "../pages/FamilyPlaza/MemorialPostBoardList/MemorialPostBoardListPC";
import MemorialPostBoardListMobile from "../pages/FamilyPlaza/MemorialPostBoardList/MemorialPostBoardListMobile";
import MemorialPostWritingPC from "../pages/FamilyPlaza/MemorialPostBoardList/MemorialPostWriting/MemorialPostWritingPC.jsx";
import MemorialPostWritingMobile from "../pages/FamilyPlaza/MemorialPostBoardList/MemorialPostWriting/MemorialPostWritingMobile.jsx";
import MemorialPostDetailsPC from "../pages/FamilyPlaza/MemorialPostBoardList/MemorialPostDetails/MemorialPostDetailsPC.jsx";
import MemorialPostDetailsMobile from "../pages/FamilyPlaza/MemorialPostBoardList/MemorialPostDetails/MemorialPostDetailsMobile.jsx";
import MemorialAlbumBoardListPC from "../pages/FamilyPlaza/MemorialAlbumBoardList/MemorialAlbumBoardListPC";
import MemorialAlbumBoardListMobile from "../pages/FamilyPlaza/MemorialAlbumBoardList/MemorialAlbumBoardListMobile";
import MemorialAlbumWritingPC from "../pages/FamilyPlaza/MemorialAlbumBoardList/MemorialAlbumWritingPC";
import MemorialAlbumWritingMobile from "../pages/FamilyPlaza/MemorialAlbumBoardList/MemorialAlbumWritingMobile";
import MemorialAlbumArticleDetailsPC from "../pages/FamilyPlaza/MemorialAlbumBoardList/MemorialAlbumArticleDetails/MemorialAlbumArticleDetailsPC.jsx";
import MemorialAlbumArticleDetailsMobile from "../pages/FamilyPlaza/MemorialAlbumBoardList/MemorialAlbumArticleDetails/MemorialAlbumArticleDetailsMobile.jsx";
import LetterToHeavenBoardListPC from "../components/LetterToHeavenBoardListPC";
import LetterToHeavenBoardListMobile from "../components/LetterToHeavenBoardListMobile";
import LetterToHeavenWritingPC from "../components/LetterToHeavenWritingPC";
import LetterToHeavenWritingMobile from "../components/LetterToHeavenWritingMobile";
import LetterToHeavenPostDetailsPC from "../components/LetterToHeavenPostDetailsPC";
import LetterToHeavenPostDetailsMobile from "../components/LetterToHeavenPostDetailsMobile";

// Funeral info (PC & Mobile)
import CyberMemorialSearchPC from "../pages/FamilyPlaza/CyberMemorialSearch/CyberMemorialSearchPC.jsx";
import CyberMemorialSearchMobile from "../pages/FamilyPlaza/CyberMemorialSearch/CyberMemorialSearchMobile.jsx";
import DonateMobile from "../pages/FamilyPlaza/Donate/DonateMobile.jsx";
import DonatePC from "../pages/FamilyPlaza/Donate/DonatePC.jsx";
import DonateRegistrationPC from "../pages/FamilyPlaza/Donate/DonateRegistrationPC.jsx";
import ManagementFeePaymentInquiryPC from "../pages/FamilyPlaza/PaymentInquiry/ManagementFeePaymentInquiry/ManagementFeePaymentInquiryPC";
import ManagementFeeInquiryResultsPC from "../pages/FamilyPlaza/PaymentInquiry/ManagementFeeInquiryResults/ManagementFeeInquiryResultsPC";
import ManagementFeePaymentInquiryMobile from "../pages/FamilyPlaza/PaymentInquiry/ManagementFeePaymentInquiry/ManagementFeePaymentInquiryMobile.jsx";
import ManagementSearchMobile from "../components/ManagementSearchMobile";
import ManagementFeeInquiryResultsMobile from "../pages/FamilyPlaza/PaymentInquiry/ManagementFeeInquiryResults/ManagementFeeInquiryResultsMobile.jsx";

/** =========================
 * Responsive wrappers
 * =======================*/

export const ResponsiveLogin = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className="mobile-frame">
                <div className="mobile-login">
                    <Login />
                </div>
            </div>
            <div className="desktop-login">
                <LoginPC />
            </div>
        </>
    );
};

export const ResponsiveSignup = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-signup">
                <Signup />
            </div>
        </div>
        <div className="desktop-signup">
            <SignupPC />
        </div>
    </>
);

export const ResponsiveFindAccount = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-find-account">
                <FindAccount />
            </div>
        </div>
        <div className="desktop-find-account">
            <FindAccountPC />
        </div>
    </>
);

export const ResponsiveFindIdResult = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);

        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    return isMobile ? (
        <div className="mobile-frame">
            <div className="mobile-find-id-result">
                <FindIdResultPC />
            </div>
        </div>
    ) : (
        <div className="desktop-find-id-result">
            <FindIdResultPC />
        </div>
    );
};

export const ResponsivePasswordReset = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-password-reset">
                <PasswordReset />
            </div>
        </div>
        <div className="desktop-password-reset">
            <PasswordResetPC />
        </div>
    </>
);

export const ResponsiveEditInfo = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-edit-info">
                <EditInfo />
            </div>
        </div>
        <div className="desktop-edit-info">
            <EditInfoPC />
        </div>
    </>
);

export const ResponsiveHome = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-home">
                <Home />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-home">
                <HomePC />
            </div>
        </div>
    </>
);


// Memorial pages

export const ResponsiveAncestralTablet = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-ancestral-tablet">
                <AncestralTabletMobile />
            </div>
        </div>
        <div className="desktop-ancestral-tablet">
            <AncestralTabletPC />
        </div>
    </>
);

export const ResponsiveLetterToHeavenBoardList = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-letter-to-heaven-board-list">
                <LetterToHeavenBoardListMobile />
            </div>
        </div>
        <div className="desktop-letter-to-heaven-board-list">
            <LetterToHeavenBoardListPC />
        </div>
    </>
);

export const ResponsiveLetterToHeavenWriting = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-letter-to-heaven-writing">
                <LetterToHeavenWritingMobile />
            </div>
        </div>
        <div className="desktop-letter-to-heaven-writing">
            <LetterToHeavenWritingPC />
        </div>
    </>
);

export const ResponsiveLetterToHeavenPostDetails = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-letter-to-heaven-post-details">
                <LetterToHeavenPostDetailsMobile />
            </div>
        </div>
        <div className="desktop-letter-to-heaven-post-details">
            <LetterToHeavenPostDetailsPC />
        </div>
    </>
);

export const ResponsiveManagementFeePaymentInquiry = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);

        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    return isMobile ? (
        <div className="mobile-frame">
            <div className="mobile-management-fee-payment-inquiry">
                <ManagementFeePaymentInquiryMobile />
            </div>
        </div>
    ) : (
        <div className="desktop-management-fee-payment-inquiry">
            <ManagementFeePaymentInquiryPC />
        </div>
    );
};

export const ResponsiveManagementFeeInquiryResults = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);

        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    return isMobile ? (
        <div className="mobile-frame">
            <div className="mobile-management-fee-inquiry-results">
                <ManagementFeeInquiryResultsMobile />

            </div>
        </div>
    ) : (
        <div className="desktop-management-fee-inquiry-results">
            <ManagementFeeInquiryResultsPC />
        </div>
    );
};

export const ResponsiveManagementSearch = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);

        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    return isMobile ? (
        <div className="mobile-frame">
            <div className="mobile-management-search">
                <ManagementSearchMobile />
            </div>
        </div>
    ) : (
        <div className="desktop-management-search">
            <ManagementFeePaymentInquiryPC />
        </div>
    );
};

export const ResponsiveProductInfo = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-product-info">
                <ProductInfoMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-product-info">
                <ProductInfoPC />
            </div>
        </div>
    </>
);

export const ResponsiveServiceAdvantages = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-service-advantages">
                <ServiceAdvantagesMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-service-advantages">
                <ServiceAdvantagesPC />
            </div>
        </div>
    </>
);

export const ResponsiveEventProcedure = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-event-procedure">
                <EventProcedureMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-event-procedure">
                <EventProcedurePC />
            </div>
        </div>
    </>
);

export const ResponsiveOpeningMoving = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-opening-moving">
                <OpeningMovingMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-opening-moving">
                <OpeningMovingPC />
            </div>
        </div>
    </>
);

// Funeral info responsive
export const ResponsiveFuneralInformationReligious = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-funeral-information-religious">
                <FuneralInfoReligiousMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-funeral-information-religious">
                <FuneralInformationReligiousPC />
            </div>
        </div>
    </>
);

export const ResponsiveFuneralMethods = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-funeral-methods">
                <FuneralMethodsMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-funeral-methods">
                <FuneralMethodsPC />
            </div>
        </div>
    </>
);

export const ResponsiveGeneralFuneralProcedures = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-general-funeral-procedures">
                <GeneralFuneralProceduresMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-general-funeral-procedures">
                <GeneralFuneralProceduresPC />
            </div>
        </div>
    </>
);

export const ResponsiveFuneralInformationOther = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-funeral-information-other">
                <FuneralInfoOtherMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-funeral-information-other">
                <FuneralInformationOtherPC />
            </div>
        </div>
    </>
);

export const ResponsiveCyberMemorialSearch = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-cyber-memorial-search">
                <CyberMemorialSearchMobile />
            </div>
        </div>
        <div className="desktop-cyber-memorial-search">
            <CyberMemorialSearchPC />
        </div>
    </>
);

export const ResponsiveDonate = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-donate">
                <DonateMobile />
            </div>
        </div>
        <div className="desktop-donate">
            <DonatePC />
        </div>
    </>
);

export const ResponsiveDonateRegistration = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-donate-registration">
                <DonateRegistrationPC />
            </div>
        </div>
        <div className="desktop-donate-registration">
            <DonateRegistrationPC />
        </div>
    </>
);

// Signup complete
export const ResponsiveSignupComplete = () => {
    return (
        <>
            <div className="mobile-frame">
                <div className="mobile-signup-complete">
                    <SignupComplete />
                </div>
            </div>
            <div className="desktop-signup-complete">
                <SignupComplete />
            </div>
        </>
    );
};

// Sales pages (marketing)
export const ResponsiveSkyHallSpecialRoom = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-sky-hall-special-room">
                <SkyHallSpecialRoomMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-sky-hall-special-room">
                <SkyHallSpecialRoomPC />
            </div>
        </div>
    </>
);

export const ResponsiveSkyHallPhoenixRoom = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-sky-hall-phoenix-room">
                <SkyHallPhoenixRoomMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-sky-hall-phoenix-room">
                <SkyHallPhoenixRoomPC />
            </div>
        </div>
    </>
);

export const ResponsiveSkyHallVIP = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-sky-hall-vip">
                <SkyHallVIPMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-sky-hall-vip">
                <SkyHallVIPPC />
            </div>
        </div>
    </>
);

export const ResponsiveStarHall = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-star-hall">
                <StarHallMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-star-hall">
                <StarHallPC />
            </div>
        </div>
    </>
);

export const ResponsiveSunlightHall = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-sunlight-hall">
                <SunlightHallMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-sunlight-hall">
                <SunlightHallPC />
            </div>
        </div>
    </>
);

export const ResponsiveSHall = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-s-hall">
                <SHallMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-s-hall">
                <SHallPC />
            </div>
        </div>
    </>
);

export const ResponsiveOutdoorHall = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-outdoor-hall">
                <OutdoorHallMobile />
            </div>
        </div>
        <div className="desktop-frame">
            <div className="desktop-outdoor-hall">
                <OutdoorHallPC />
            </div>
        </div>
    </>
);

export const ResponsiveMemorialPostBoardList = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-memorial-post-board-list">
                <MemorialPostBoardListMobile />
            </div>
        </div>
        <div className="desktop-memorial-post-board-list">
            <MemorialPostBoardListPC />
        </div>
    </>
);

export const ResponsiveMemorialPostWriting = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-memorial-post-writing">
                <MemorialPostWritingMobile />
            </div>
        </div>
        <div className="desktop-memorial-post-writing">
            <MemorialPostWritingPC />
        </div>
    </>
);

export const ResponsiveMemorialAlbumBoardList = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-memorial-album-board-list">
                <MemorialAlbumBoardListMobile />
            </div>
        </div>
        <div className="desktop-memorial-album-board-list">
            <MemorialAlbumBoardListPC />
        </div>
    </>
);

export const ResponsiveMemorialPostDetails = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-memorial-post-details">
                <MemorialPostDetailsMobile />
            </div>
        </div>
        <div className="desktop-memorial-post-details">
            <MemorialPostDetailsPC />
        </div>
    </>
);

export const ResponsiveMemorialAlbumWriting = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-memorial-album-writing">
                <MemorialAlbumWritingMobile />
            </div>
        </div>
        <div className="desktop-memorial-album-writing">
            <MemorialAlbumWritingPC />
        </div>
    </>
);

export const ResponsiveMemorialAlbumArticleDetails = () => (
    <>
        <div className="mobile-frame">
            <div className="mobile-memorial-album-article-details">
                <MemorialAlbumArticleDetailsMobile />
            </div>
        </div>
        <div className="desktop-memorial-album-article-details">
            <MemorialAlbumArticleDetailsPC />
        </div>
    </>
);

/** Mobile-only exports you referenced directly in routes.js to keep parity */
export {
    AnnouncementList,
    AnnouncementDetails,
    MemorialNewsList,
    MemorialNewsDetails,
    PrivacyPolicy,
    ServiceUseNotice,
    RefusalOfUnauthorized,
    TermsCondition,
    FAQCustomerCenter,
    ContactUs,
    InquiryDetails,
    ContactUsWriting,
    SecretPost,
    SaleInfo,
    MemorialGalleryListPC,
    GalleryDetailsPC,
    DirectionsPC,
    FacilityGuidePC,
    CEOGreetingPC,
    IntroductionPC,
    TakeLookPCFullView,
    TakeLookPCSkyHall,
    TakeLookPCSunlightHall,
    TakeLookPCSHall,
    TakeLookPCAHall,
    TakeLookPCSkyHallVIP,
    TakeLookPCStarlightHall,
    TakeLookPCFamilyHall,
    TakeLookPCOutdoorHall
};
